<template>
  <location-form
    v-model="locationData"
    :wizard-token="wizardToken"
    :scope-name="apiRoot"
    :handle-back="handleBack"
    :handle-confirm="handleConfirm"
    :show-final-cancel="false"
    :show-back-btn="true"
  ></location-form>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

import { debounce } from "utilities/utilities";
import LocationForm from "location/components/LocationForm";

const { mapActions, mapState } = createNamespacedHelpers("registration");

export default {
  name: "RegistrationLocation",

  components: {
    LocationForm,
  },

  computed: {
    ...mapState(["wizardToken", "apiRoot"]),

    locationData: {
      get() {
        return this.$store.getters.getLocation;
      },

      set(location) {
        this.$store.commit("registration/location", location);
      },
    },
  },

  watch: {
    locationData(newLocation, oldLocation) {
      const locationChanged = Object.keys(newLocation).some((key) => {
        return newLocation[key] !== oldLocation[key];
      });

      if (locationChanged) this.debouncedLocationUpdate(newLocation);
    },
  },

  created() {
    this.debouncedLocationUpdate = debounce((newLocation) => {
      this.updateLocation(newLocation);
    }, 500);
  },

  methods: {
    ...mapActions(["updateLocation"]),

    handleBack() {
      this.$router.push({ name: "data-use" });
    },

    handleConfirm() {
      this.$router.push({ name: "age" });
    },
  },
};
</script>
